import { MarketType, markets } from 'constants/markets';
import { getReferrerMarket } from 'server/getReferrerMarket';
import { isRenderingOnServer } from 'server/isRenderingOnServer';
import { create } from 'zustand';

type MarketStoreType = typeof markets[keyof typeof markets] & {
    setMarket: (market: MarketType) => void;
    isMarketInitiated: boolean;
};

const initialMarket = !isRenderingOnServer()
    ? getReferrerMarket(window.location.href)
    : markets.se.market;

const useMarket = create<MarketStoreType>((set) => ({
    ...markets[initialMarket],
    isMarketInitiated: false,
    setMarket: (market) => set({
        ...markets[market],
        isMarketInitiated: true,
    }),
}));

export default useMarket;
